import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SEOHead from '@/components/feature/SEOHead';
import { aboutTimeline } from '@/mocks/testimonialsData';

const teamMembers = [
  {
    name: '李樱花',
    role: '创始人 & CEO',
    description: '资深动漫爱好者，前互联网大厂产品经理，致力于打造最好的动漫平台。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20anime%20style%20portrait%20of%20young%20Asian%20woman%2C%20confident%20expression%2C%20simple%20clean%20background%2C%20warm%20colors%2C%20semi-realistic%20anime%20art&width=160&height=160&seq=team-avatar-001&orientation=squarish',
  },
  {
    name: '张动漫',
    role: '内容总监',
    description: '十年动漫媒体从业经验，资深动漫评论人，曾任职多家动漫杂志。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20anime%20style%20portrait%20of%20young%20Asian%20man%20with%20glasses%2C%20friendly%20expression%2C%20simple%20clean%20background%2C%20warm%20colors&width=160&height=160&seq=team-avatar-002&orientation=squarish',
  },
  {
    name: '王二次',
    role: '技术负责人',
    description: '全栈工程师，移动端性能优化专家，确保平台流畅的用户体验。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20anime%20style%20portrait%20of%20young%20Asian%20tech%20worker%2C%20casual%20confident%20look%2C%20simple%20clean%20background%2C%20warm%20colors&width=160&height=160&seq=team-avatar-003&orientation=squarish',
  },
  {
    name: '赵番剧',
    role: '运营总监',
    description: '擅长社区运营和用户增长，打造了樱花动漫活跃的用户社区生态。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20anime%20style%20portrait%20of%20young%20Asian%20woman%20smiling%2C%20friendly%20vibe%2C%20simple%20clean%20background%2C%20warm%20colors&width=160&height=160&seq=team-avatar-004&orientation=squarish',
  },
];

const mediaReviews = [
  {
    id: 'media-001',
    name: '动漫周刊',
    role: '权威动漫媒体',
    content: '樱花动漫以其出色的移动端体验和全面的内容覆盖，已成为国内动漫爱好者的首选门户之一。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20media%20logo%20style%20icon%2C%20simple%20geometric%20design%2C%20clean%20background%2C%20minimalist%20corporate%20style&width=80&height=80&seq=media-avatar-001&orientation=squarish',
  },
  {
    id: 'media-002',
    name: 'ACG观察站',
    role: '知名二次元媒体',
    content: '从番剧更新到深度分析，樱花动漫的内容质量在同类型平台中首屈一指。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20media%20logo%20style%20icon%2C%20circular%20geometric%20design%2C%20clean%20background%2C%20minimalist%20corporate%20style&width=80&height=80&seq=media-avatar-002&orientation=squarish',
  },
  {
    id: 'media-003',
    name: '二次元专栏',
    role: '站内精选推荐',
    content: '樱花动漫的国漫专区和文章推荐功能，为广大动漫爱好者提供了一个高质量的交流平台。',
    avatarUrl: 'https://readdy.ai/api/search-image?query=Professional%20media%20logo%20style%20icon%2C%20play%20button%20design%2C%20clean%20background%2C%20minimalist%20corporate%20style&width=80&height=80&seq=media-avatar-003&orientation=squarish',
  },
];

export default function AboutPage() {
  return (
    <>
      <SEOHead
        title="关于我们 - 品牌介绍与联系方式 - 樱花动漫网"
        description="樱花动漫专注手机动漫门户，了解我们的品牌故事、团队理念与联系方式，致力于为您提供最优质的手机动漫浏览体验。地址：北京市朝阳区动漫产业园区A座1208室，客服电话：400-888-0666。"
        keywords="樱花动漫,关于我们,品牌介绍,联系方式,动漫门户,北京动漫公司"
        canonicalUrl="http://knsink.cn/about"
        ogImage="https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20illustration%20of%20cherry%20blossom%20tree%20in%20full%20bloom%2C%20soft%20pink%20petals%2C%20warm%20sunlight%2C%20Japanese%20aesthetic%2C%20dreamy%20atmosphere%2C%20gentle%20color%20palette%2C%20branding%20visual&width=1200&height=630&seq=about-og-image&orientation=landscape"
        jsonLd={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于樱花动漫',
            description: '了解樱花动漫的品牌故事、发展历程与团队信息',
            url: 'http://knsink.cn/about',
            about: {
              '@type': 'Organization',
              name: '樱花动漫',
              description: '专注手机动漫的门户网站，成立于2018年，致力于为动漫爱好者提供最优质的手机动漫浏览体验。',
              url: 'http://knsink.cn/',
              foundingDate: '2018',
              address: {
                '@type': 'PostalAddress',
                streetAddress: '朝阳区动漫产业园区 A座 1208室',
                addressLocality: '北京',
                addressRegion: '北京',
                addressCountry: 'CN',
                postalCode: '100000',
              },
              contactPoint: {
                '@type': 'ContactPoint',
                telephone: '+86-400-888-0666',
                contactType: 'customer service',
                availableLanguage: ['Chinese'],
                hoursAvailable: {
                  '@type': 'OpeningHoursSpecification',
                  dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                  opens: '09:00',
                  closes: '18:00',
                },
              },
              email: 'hello@knsink.cn',
            },
          },
          {
            '@context': 'https://schema.org',
            '@type': 'BreadcrumbList',
            itemListElement: [
              { '@type': 'ListItem', position: 1, name: '首页', item: 'http://knsink.cn/' },
              { '@type': 'ListItem', position: 2, name: '关于我们' },
            ],
          },
          {
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: '樱花动漫是什么时候成立的？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '樱花动漫成立于2018年，是一家专注于手机端的动漫门户网站，目前已发展成为日活用户突破500万的行业领先平台。',
                },
              },
              {
                '@type': 'Question',
                name: '如何联系樱花动漫的客服团队？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '您可以通过客服电话400-888-0666（周一至周五9:00-18:00）联系我们，hello@knsink.cn，我们会在48小时内回复。公司地址位于北京市朝阳区动漫产业园区A座1208室。',
                },
              },
              {
                '@type': 'Question',
                name: '樱花动漫支持商务合作吗？',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: '樱花动漫欢迎各类商务合作，包括广告投放、IP联名、内容合作等。请通过hello@knsink.cn与我们联系，我们的商务团队会尽快与您接洽。',
                },
              },
            ],
          },
        ]}
      />
      <Navbar />
      <main>
        <section className="w-full bg-background-50 py-16 md:py-24">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
              <div className="w-full lg:w-2/5">
                <span className="inline-block px-3 py-1 rounded-full border border-primary-300 text-primary-600 text-xs font-medium mb-4">
                  关于我们
                </span>
                <img
                  src="https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20illustration%20of%20cherry%20blossom%20tree%20in%20full%20bloom%2C%20soft%20pink%20petals%2C%20warm%20sunlight%2C%20Japanese%20aesthetic%2C%20dreamy%20atmosphere%2C%20gentle%20color%20palette&width=700&height=900&seq=about-brand&orientation=portrait"
                  alt="樱花动漫品牌"
                  className="w-full rounded-lg"
                  loading="lazy"
                />
              </div>
              <div className="w-full lg:w-3/5">
                <h1 className="text-2xl md:text-4xl lg:text-5xl font-bold font-heading text-foreground-900 leading-tight">
                  <span className="block">专注手机动漫</span>
                  <span className="block mt-2">打造最优质的</span>
                  <span className="block mt-2">
                    <span className="text-primary-500">二次元</span>门户
                  </span>
                </h1>
                <p className="mt-6 text-sm md:text-base text-foreground-600 leading-relaxed max-w-xl">
                  樱花动漫成立于2018年，是一家专注于手机端的动漫门户网站。我们的使命是让每一位动漫爱好者都能随时随地畅享二次元世界的精彩。从番剧更新到深度分析，从国漫专区到社区互动，我们致力于打造全方位、高品质的动漫内容生态。
                </p>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-xl">
                  我们相信，动漫不仅仅是娱乐，更是一种文化和生活方式。樱花动漫将始终坚持以用户为中心，不断优化产品体验，为中国的动漫产业发展贡献力量。
                </p>
                <a
                  href="mailto:hello@knsink.cn"
                  className="mt-6 inline-flex items-center gap-2 px-6 py-2.5 rounded-lg bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
                >
                  联系我们
                  <i className="ri-mail-line"></i>
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-900">
                发展<span className="text-primary-500">历程</span>
              </h2>
              <p className="mt-3 text-sm text-foreground-500">一步一个脚印，我们在不断成长</p>
            </div>

            <div className="flex flex-col lg:flex-row gap-4 md:gap-5">
              <div className="w-full lg:w-1/2">
                <div className="group block relative w-full aspect-[4/5] lg:aspect-[3/4] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Artistic%20anime%20style%20community%20illustration%2C%20diverse%20characters%20gathered%20together%2C%20warm%20atmosphere%2C%20soft%20lighting%2C%20Japanese%20anime%20aesthetic%2C%20harmonious%20color%20palette&width=800&height=1100&seq=about-philosophy&orientation=portrait"
                    alt="品牌理念"
                    className="w-full h-full object-cover object-top"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                  <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                    <span className="inline-block px-2.5 py-1 rounded-full bg-primary-500 text-background-50 text-xs font-medium mb-2">
                      品牌理念
                    </span>
                    <h3 className="text-lg md:text-xl font-bold font-heading text-background-50">
                      让动漫触手可及
                    </h3>
                    <p className="mt-1 text-xs text-background-200">
                      以用户体验为核心，打造最便捷的手机动漫浏览平台
                    </p>
                  </div>
                </div>
              </div>

              <div className="w-full lg:w-1/2 flex flex-col gap-4 md:gap-5">
                <div className="group block relative w-full aspect-[16/7] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Modern%20office%20data%20dashboard%20with%20graphs%2C%20clean%20minimalist%20design%2C%20warm%20lighting%2C%20professional%20atmosphere%2C%20soft%20sage%20green%20accents&width=900&height=400&seq=about-stats&orientation=landscape"
                    alt="数据成就"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 p-4 md:p-5">
                    <span className="inline-block px-2 py-0.5 rounded-full bg-secondary-500 text-background-50 text-xs font-medium mb-1.5">
                      数据成就
                    </span>
                    <h3 className="text-base md:text-lg font-bold font-heading text-background-50">
                      日活用户突破500万
                    </h3>
                  </div>
                </div>

                <div className="group block relative w-full aspect-[16/7] rounded-lg overflow-hidden">
                  <img
                    src="https://readdy.ai/api/search-image?query=Warm%20community%20gathering%20scene%2C%20anime%20fans%20sharing%20together%2C%20soft%20pink%20and%20warm%20tones%2C%20cozy%20atmosphere%2C%20lifestyle%20photography&width=900&height=400&seq=about-community&orientation=landscape"
                    alt="社区氛围"
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-transparent"></div>
                  <div className="absolute bottom-0 left-0 p-4 md:p-5">
                    <span className="inline-block px-2 py-0.5 rounded-full bg-accent-500 text-background-50 text-xs font-medium mb-1.5">
                      社区氛围
                    </span>
                    <h3 className="text-base md:text-lg font-bold font-heading text-background-50">
                      千万动漫迷的聚集地
                    </h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-900">
                发展<span className="text-primary-500">时间线</span>
              </h2>
            </div>
            <div className="max-w-3xl mx-auto">
              <div className="relative">
                <div className="absolute left-4 md:left-1/2 top-0 bottom-0 w-px bg-background-200 hidden md:block"></div>
                <div className="flex flex-col gap-6">
                  {aboutTimeline.map((item, index) => (
                    <div
                      key={item.year}
                      className={`flex flex-col md:flex-row gap-4 md:gap-8 ${
                        index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
                      }`}
                    >
                      <div className={`flex-1 ${index % 2 === 0 ? 'md:text-right' : 'md:text-left'}`}>
                        <div className="bg-background-100 rounded-lg p-4 md:p-5">
                          <span className="text-xs font-bold text-primary-500">{item.year}</span>
                          <h3 className="text-sm font-bold font-heading text-foreground-900 mt-1">{item.title}</h3>
                          <p className="text-xs text-foreground-600 mt-1 leading-relaxed">{item.description}</p>
                        </div>
                      </div>
                      <div className="hidden md:flex items-center justify-center flex-shrink-0">
                        <div className="w-3 h-3 rounded-full bg-primary-500 ring-4 ring-primary-100"></div>
                      </div>
                      <div className="hidden md:block flex-1"></div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-900">
                团队<span className="text-primary-500">成员</span>
              </h2>
              <p className="mt-3 text-sm text-foreground-500">一群热爱动漫的人，用心做好每一件事</p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-5">
              {teamMembers.map((member) => (
                <div key={member.name} className="bg-background-50 rounded-lg p-5 text-center">
                  <img
                    src={member.avatarUrl}
                    alt={member.name}
                    className="w-20 h-20 rounded-full object-cover mx-auto mb-3"
                    loading="lazy"
                  />
                  <h3 className="text-sm font-semibold text-foreground-900">{member.name}</h3>
                  <p className="text-xs text-primary-500 mt-0.5">{member.role}</p>
                  <p className="text-xs text-foreground-500 mt-2 leading-relaxed">{member.description}</p>
                </div>
              ))}
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="text-center mb-10 md:mb-14">
              <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-primary-100 mb-4">
                <i className="ri-double-quotes-l text-xl text-primary-500"></i>
              </div>
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-900">
                媒体<span className="text-primary-500">口碑</span>
              </h2>
              <p className="mt-3 text-sm text-foreground-500">权威动漫媒体的评价</p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
              {mediaReviews.slice(0, 2).map((review) => (
                <div key={review.id} className="bg-background-100 rounded-lg p-5 md:p-6 flex flex-col">
                  <div className="flex items-center gap-3 mb-4">
                    <img
                      src={review.avatarUrl}
                      alt={review.name}
                      className="w-10 h-10 rounded-full object-cover"
                      loading="lazy"
                    />
                    <div>
                      <p className="text-sm font-semibold text-foreground-900">{review.name}</p>
                      <p className="text-xs text-foreground-500">{review.role}</p>
                    </div>
                  </div>
                  <i className="ri-double-quotes-l text-2xl text-primary-200 mb-2"></i>
                  <p className="text-sm text-foreground-700 leading-relaxed flex-1">{review.content}</p>
                </div>
              ))}

              <div className="relative rounded-lg overflow-hidden aspect-[3/4] md:aspect-auto">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20anime%20media%20event%20photography%2C%20panel%20discussion%2C%20warm%20stage%20lighting%2C%20professional%20atmosphere%2C%20Japanese%20anime%20convention%20vibe&width=600&height=800&seq=about-media-photo&orientation=portrait"
                  alt="媒体赞誉"
                  className="w-full h-full object-cover"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <p className="text-sm font-semibold text-background-50">{mediaReviews[2].name}</p>
                  <p className="text-xs text-background-300">{mediaReviews[2].role}</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-50 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <div className="relative rounded-xl md:rounded-2xl overflow-hidden mb-10 md:mb-14">
                <img
                  src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20space%20with%20anime%20posters%2C%20warm%20natural%20lighting%2C%20collaborative%20atmosphere%2C%20film%20grain%20texture%2C%20dreamy%20workspace%20photography&width=1200&height=500&seq=about-cta&orientation=landscape"
                  alt="加入我们"
                  className="w-full aspect-[21/9] object-cover"
                  loading="lazy"
                />
              </div>
              <h2 className="text-2xl md:text-4xl font-bold font-heading text-foreground-900 leading-tight">
                和我们一起<span className="italic font-heading text-primary-500">创造未来</span>
              </h2>
              <p className="mt-4 text-sm text-foreground-500 max-w-md mx-auto">
                樱花动漫正在快速发展，我们欢迎热爱动漫、有才华的你加入我们的团队
              </p>
              <a
                href="mailto:hello@knsink.cn"
                className="mt-8 inline-flex items-center gap-2 px-8 py-3 rounded-full bg-foreground-900 text-background-50 text-sm font-medium hover:bg-foreground-800 transition-colors cursor-pointer whitespace-nowrap"
              >
                加入我们
                <i className="ri-arrow-right-line"></i>
              </a>
            </div>
          </div>
        </section>

        <section className="w-full bg-background-100 py-14 md:py-20">
          <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
            <div className="max-w-2xl mx-auto">
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 text-center mb-8">
                联系<span className="text-primary-500">我们</span>
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-5">
                <div className="bg-background-50 rounded-lg p-5 text-center">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-3">
                    <i className="ri-map-pin-line text-primary-500"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">公司地址</h3>
                  <p className="text-xs text-foreground-600 leading-relaxed">
                    北京市朝阳区动漫产业园区<br />A座 1208室
                  </p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 text-center">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-3">
                    <i className="ri-phone-line text-primary-500"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">客服电话</h3>
                  <p className="text-xs text-foreground-600">+86 400-888-0666</p>
                  <p className="text-xs text-foreground-400 mt-1">周一至周五 9:00-18:00</p>
                </div>
                <div className="bg-background-50 rounded-lg p-5 text-center">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 mx-auto mb-3">
                    <i className="ri-mail-line text-primary-500"></i>
                  </div>
                  <h3 className="text-sm font-semibold text-foreground-900 mb-1">电子邮箱</h3>
                  <p className="text-xs text-foreground-600">hello@knsink.cn</p>
                  <p className="text-xs text-foreground-400 mt-1">48小时内回复</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <Breadcrumb items={[{ label: '关于我们' }]} />
      </main>
      <Footer />
    </>
  );
}
